import * as tokens from './tokens.json';
export const { colors } = tokens.global;
const { viewports: vpTokens, font_sizes: fsTokens, spacing: spTokens, border_radius: brTokens, box_shadows: bsTokens, input_heights: ihTokens, line_heights: lhTokens, } = tokens.global;
export const viewports = {
    xs: vpTokens.xs.value,
    sm: vpTokens.sm.value,
    md: vpTokens.md.value,
    lg: vpTokens.lg.value,
    xl: vpTokens.xl.value,
};
export const fontSizes = {
    sm: fsTokens.sm.value,
    md: fsTokens.md.value,
    lg: fsTokens.lg.value,
    xl: fsTokens.xl.value,
};
export const spacing = {
    xs: spTokens.xs.value,
    sm: spTokens.sm.value,
    md: spTokens.md.value,
    lg: spTokens.lg.value,
    xl: spTokens.xl.value,
    xxl: spTokens.xxl.value,
};
export const borderRadius = {
    xs: brTokens.xs.value,
    sm: brTokens.sm.value,
    md: brTokens.md.value,
    lg: brTokens.lg.value,
    xl: brTokens.xl.value,
    xxl: brTokens.xxl.value,
};
export const boxShadows = {
    sm: bsTokens.sm.value,
    lg: bsTokens.lg.value,
};
export const inputHeights = {
    xs: ihTokens.xs.value,
    sm: ihTokens.sm.value,
    md: ihTokens.md.value,
    lg: ihTokens.lg.value,
    xl: ihTokens.xl.value,
};
export const lineHeights = {
    condensed: lhTokens.condensed.value,
    normal: lhTokens.normal.value,
};
